import React from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import Theme from '../../theme';
import styles from './Styles';
import { Heading, HeadingTypes } from '../../components';

const PrivacyListHeader = ({
    t,
    listType,
    privacyPartnerList,
}) => (privacyPartnerList.length > 0 && listType === 'searchlist' ?
    <View style={styles.headingContainer}>
        <Heading
            title={t('found')}
            style={styles.header}
            headerType={HeadingTypes.HEADING_ONE}
        />
    </View> :
    privacyPartnerList.length > 0 && listType === 'whitelist' &&
    <View style={[styles.headingContainer, { paddingTop: 20 }]}>
        <Heading
            title={t('myFriends')}
            style={[styles.header, { fontFamily: Theme.Custom700 }]}
            headerType={HeadingTypes.HEADING_ONE}
        />
    </View>
);

PrivacyListHeader.propTypes = {
    t: PropTypes.func.isRequired,
    isPrivate: PropTypes.bool.isRequired,
    privacyPartnerList: PropTypes.array.isRequired,
    listType: PropTypes.oneOf(['whitelist', 'blacklist', 'searchlist']).isRequired,
};

export default PrivacyListHeader;
